import { isValidElement } from "react"

import { Grid, GridCell, Coord, CellNode, Path, FRank } from "../../../types/grid";

const MAX_G = 999999;
const MAX_H = 999999;
const MAX_F = 999999;

const MOVE_DISTANCE = 1;

export function moveUnit() {}

function IsValid(Row: number, Col: number,) {
    return  ((Col >= 0) && (Row >= 0));
}

function IsDestination(Row: number, Col: number, DestPos: Coord) {
    return (Row === DestPos.y && Col === DestPos.x);
}

function IsCellEmpty(Cell: GridCell) {

    let empty = Cell.properties.find((e: string) => (e === "impassible")) != "impassible";

    return (empty);
}

function CalculateH_Manhattan(Row: number, Col: number, DestPos: Coord) {
    return  Math.abs(Col - DestPos.x) + Math.abs(Row - DestPos.y);
}

function UpdateFRankAndSortOpenList(OpenList: FRank[], newFRank: FRank) {

    for(let openListIndex = 0; openListIndex < OpenList.length; openListIndex++)
	{
		if(OpenList[openListIndex].x === newFRank.x && OpenList[openListIndex].y === newFRank.y)
		{
			OpenList[openListIndex].f = newFRank.f;
		}
	}

	if(OpenList.length > 1)
	{
		OpenList.sort((a, b) => {
            return a.f - b.f;
        });
	}
}

function TracePath(Nodes: CellNode[][], TestPos: Coord, DestPos: Coord) {

    let path: Path = {
        coords: [],
        moveDirection: 0,
	    currentPosition: 0
    };

    let row = DestPos.y;
    let col = DestPos.x;

    let iter = 0;

    while(!(Nodes[row][col].parentRow === row && Nodes[row][col].parentCol === col)) {

        path.coords[iter++] = { y: row, x: col };

        let tempRow = Nodes[row][col].parentRow;
        let tempCol = Nodes[row][col].parentCol;

        row = tempRow;
        col = tempCol;
    }

    path.coords[iter++] = { y: row, x: col };

    path.currentPosition = iter - 1;

    return path;
}

export function AStar(Grid: Grid, StartPos: Coord, DestPos: Coord) {

    let maxRow = Grid.length;
    let maxCol = Grid[0].length;

    let startCell = Grid[StartPos.y][StartPos.x];
    let destCell = Grid[DestPos.y][DestPos.x];

    if(!IsValid(StartPos.y, StartPos.x)){
        return {
            coords: [],
            moveDirection: 0,
            currentPosition: 0,
          };
    }

    if(!IsValid(DestPos.y, DestPos.x)){
        return {
            coords: [],
            moveDirection: 0,
            currentPosition: 0,
          };
    }
    
    if(!IsCellEmpty(startCell) || !IsCellEmpty(destCell)){
        return {
            coords: [],
            moveDirection: 0,
            currentPosition: 0,
          };
    }
    
    if(IsDestination(StartPos.y, StartPos.x, DestPos)){
        return {
            coords: [],
            moveDirection: 0,
            currentPosition: 0,
          };
    }

    let openList: FRank[] = [];
    let childRanks: FRank[] = [];
    let closedList: boolean[][] = [];
    let nodes: CellNode[][] = [];

    for(let row = 0; row < maxRow; row++) {

        nodes.push([]);
        closedList.push([]);

        for(let col = 0; col < maxCol; col++) {

            nodes[row].push({
                g: MAX_G,
                h: MAX_H,
                f: MAX_F,
                parentRow: -1,
                parentCol: -1
            });

            closedList[row].push(false);
        }
    }

    let row = StartPos.y;
    let col = StartPos.x;

    nodes[row][col].f = 0;
    nodes[row][col].g = 0;
    nodes[row][col].h = 0;
    nodes[row][col].parentRow = row;
    nodes[row][col].parentCol = col;

    let startRank: FRank = {
        f: 0,
        y: StartPos.y,
        x: StartPos.x
    };

    openList.push(startRank);

    let childDirections = [
        [ 1,  0], // North
		[-1,  0], // South
		[ 0,  1], // East
		[ 0, -1]  // West 
    ];

    while(openList.length > 0) {
        
        let shortestF = openList[0];

        openList.shift();

        row = shortestF.y;
        col = shortestF.x;

        let parentNode = nodes[row][col];

        closedList[row][col] = true;

        let newG = MAX_G;
        let newH = MAX_H;
        let newF = MAX_F;

        childRanks = [
            {f : MAX_F, x : 0,  y : 0 },
            {f : MAX_F, x : 0,  y : 0 },
            {f : MAX_F, x : 0,  y : 0 },
            {f : MAX_F, x : 0,  y : 0 }
        ];

        for(let childIndex = 0; childIndex < childDirections.length; childIndex++) {

            let childRow = row + childDirections[childIndex][0];
            let childCol = col + childDirections[childIndex][1];

            if(childRow === maxRow || childCol === maxCol || childRow === -1 || childCol === -1) {
                continue;
            }

            let childNode = nodes[childRow][childCol];

            let childClosedListValue = closedList[childRow][childCol];

            let childCell = Grid[childRow][childCol];

            if(IsValid(childRow, childCol)) {
                newG = parentNode.g + MOVE_DISTANCE;
                newH = CalculateH_Manhattan(childRow, childCol, DestPos);
                newF = newG + newH;

                if(IsDestination(childRow, childCol, DestPos)) {
                    childNode.g = newG;
                    childNode.h = newH;
                    childNode.f = newF;

                    childNode.parentRow = row;
                    childNode.parentCol = col;

                    let path = TracePath(nodes, StartPos, DestPos);

                    return path;
                }
                else if(!childClosedListValue && IsCellEmpty(childCell)) {

                    if(childNode.f === MAX_F){

                        childRanks[childIndex] = {
                            f: newF,
                            y: childRow,
                            x: childCol
                        };

                        childNode.g = newG;
                        childNode.h = newH;
                        childNode.f = newF;

                        childNode.parentRow = row;
                        childNode.parentCol = col;
                    }
                    else if(childNode.f > newF)
                    {
                        let newFRank = {
                            f: newF,
                            y: childRow,
                            x: childCol
                        };

                        UpdateFRankAndSortOpenList(openList, newFRank);
                    }
                }
            }
        }

        if(childRanks.length > 0)
        {
            openList = openList.concat(childRanks);

            openList.sort((a, b) => {
                return a.f - b.f;
            });
        }
    }

    return {
        coords: [],
        moveDirection: 0,
        currentPosition: 0,
      };
}